import { Coins } from "lucide-react";

export const CreditBalanceLoadingView = () => {
  return (
    <div className="relative flex items-center">
      <div className="flex animate-pulse items-center gap-3 rounded-full border border-border bg-surface-subtle/50 px-4 py-1.5 shadow-sm">
        <div className="rounded-full bg-muted p-1">
          <Coins size={14} className="text-text-faint" />
        </div>

        <div className="flex flex-col -space-y-0.5">
          <span className="text-2xs font-semibold uppercase tracking-micro text-text-faint">
            Credits
          </span>
          <div className="flex items-center gap-1.5">
            <span className="text-sm font-bold tabular-nums text-text-faint">—</span>
            <span className="text-2xs font-bold tabular-nums text-text-faint">/ —</span>
          </div>
        </div>

        {/* Placeholder progress bar */}
        <div className="h-1.5 w-12 overflow-hidden rounded-full bg-border/50">
          <div className="h-full w-0 rounded-full" />
        </div>
      </div>
    </div>
  );
};
